import { colorSchemeTokens } from '@sixui/ui/themes/base/colorScheme.stylex';
import { shapeTokens } from '@sixui/ui/themes/base/shape.stylex';
import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';

export type IBreadcrumbsTextProps = IContainerProps & {
  children: React.ReactNode;
  current?: boolean;
};

const styles = stylex.create({
  host: {
    display: 'flex',
    justifyItems: 'center',
    gap: '0.375rem',
    overflow: 'hidden',
    borderRadius: shapeTokens.corner$xs,
    paddingLeft: '0.5rem',
    paddingRight: '0.5rem',
    paddingTop: '0.25rem',
    paddingBottom: '0.25rem',
    alignItems: 'center',
    color: colorSchemeTokens.onSurfaceVariant,
  },
  host$current: {
    color: colorSchemeTokens.onSurface,
  },
});

export const BreadcrumbsText: React.FC<IBreadcrumbsTextProps> = ({
  sx,
  children,
  current,
}) => (
  <div {...stylex.props(styles.host, current && styles.host$current, sx)}>
    {children}
  </div>
);
